import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Typography } from 'app/component-library-wave';
import { Arrow } from 'app/media';
import { getDataLayers } from 'app/utils/trackingService';
import { anonymizeUrl, getAnonymizedCurrentPageUrl } from 'app/utils/gtm-tracking-utils';

import styles from './navigation-link.module.scss';

interface Props {
  to: string;
  text: string;
  direction: 'left' | 'right';
  className?: string;
  gtmElementCta?: string;
}

const handleClick = (gtmElementCta: string | undefined, to: string) => {
  if (gtmElementCta) {
    getDataLayers().customEvents.pushButtonClickEvent({
      element_cta: gtmElementCta,
      page_url: getAnonymizedCurrentPageUrl(),
      element_url: anonymizeUrl(to),
    });
  }
};

export const NavigationLink: React.FC<Props> = (props) => {
  const { to, text, direction, className, gtmElementCta } = props;

  return (
    <Link to={to} className={classNames(styles.link, className)} onClick={() => handleClick(gtmElementCta, to)}>
      {direction === 'left' && (
        <Arrow direction={direction} variant="long" role="presentation" className={styles.arrowLeft} />
      )}
      <Typography variant="uiText2" component="span" bold={true} className={styles.text}>
        {text}
      </Typography>
      {direction === 'right' && (
        <Arrow direction={direction} variant="long" role="presentation" className={styles.arrowRight} />
      )}
    </Link>
  );
};
